import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const FlowDownstreamSheetsQueryGql: DocumentNode = gql`
query FlowDownstreamSheetsQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
